<ng-container>
  <form [formGroup]="publicPrivateConcessionAgreementsPolicyFg">
    <div class="row">
      <div class="col col-1 pt-3" style="width: 400px">
        <p style="padding: 6px">Grondslag van publiek-private concessieovereenkomsten</p>
      </div>
      <div class="col-2 pt-3">
        <snelstart-ui-button type="secondary"
                             icon="{{ this.publicPrivateConcessionAgreementsPolicyFg.get('value')?.getRawValue() ? 'pencil' : 'plus' }}"
                             class="custom-input-150"
                             (click)="this.showDialog(0)">
          {{ this.publicPrivateConcessionAgreementsPolicyFg.get('value')?.getRawValue() ? 'Aanpassen' : 'Invullen' }}
        </snelstart-ui-button>
      </div>
      @if (isRechtspersoon) {
        <div class="col-3">
          <snelstart-ui-select-form-control formControlName="includeInKvkReport"
                                            label="In publicatiestukken"
                                            [options]="this.optionsJaNee"
                                            [required]=true
                                            class="me-1 custom-input-150"
                                            (change)="this.saveForm()"
          >
          </snelstart-ui-select-form-control>
        </div>
      }
    </div>
  </form>
  <form [formGroup]="licensingAgreementsDisclosureFg">
    <div class="row">
      <div class="col col-1" style="width: 400px">
        <p style="padding: 6px">Informatieverschaffing over concessies</p>
      </div>
      <div class="col-2">
        <snelstart-ui-button type="secondary"
                             icon="{{ this.licensingAgreementsDisclosureFg.get('value')?.getRawValue() ? 'pencil' : 'plus' }}"
                             class="custom-input-150"
                             (click)="this.showDialog(1)">
          {{ this.licensingAgreementsDisclosureFg.get('value')?.getRawValue() ? 'Aanpassen' : 'Invullen' }}
        </snelstart-ui-button>
      </div>
      @if (isRechtspersoon) {
        <div class="col-3">
          <snelstart-ui-select-form-control formControlName="includeInKvkReport"
                                            [options]="this.optionsJaNee"
                                            [required]=true
                                            class="me-1 custom-input-150"
                                            (change)="this.saveForm()"
          >
          </snelstart-ui-select-form-control>
        </div>
      }
    </div>
  </form>
</ng-container>

<div *ngIf="this.index === 0">
  <snelstart-venture-fiscaal-feature-spec-formattedexplanation [(dialogVisible)]="this.dialogVisible"
                                                               [(input)]="this.publicPrivateConcessionAgreementsPolicyFg"
                                                               [title]="'Grondslag van publiek-private concessieovereenkomsten'"
                                                               (inputChange)="this.saveForm()"></snelstart-venture-fiscaal-feature-spec-formattedexplanation>
</div>
<div *ngIf="this.index === 1">
  <snelstart-venture-fiscaal-feature-spec-formattedexplanation [(dialogVisible)]="this.dialogVisible"
                                                               [(input)]="this.licensingAgreementsDisclosureFg"
                                                               [title]="'Informatieverschaffing over concessies'"
                                                               (inputChange)="this.saveForm()"></snelstart-venture-fiscaal-feature-spec-formattedexplanation>
</div>

